<template>
    <div>
        <!-- Tabel Sarana -->
        <div class="card">
            <div class="card-header">
                <div class="col-12 col-lg-12">
                    <div class="row">
                        <div class="col-6 col-lg-6 order-1 order-lg-1">
                            <h5
                                style="
                                    vertical-align: middle !important;
                                    float: left !important;
                                "
                            >
                                Data Sarana (Light Vihicle)
                                
                            </h5>
                        </div>
                        <div class="col-6 col-lg-6 order-2 order-lg-2">
                            <div class="col-12 col-lg-12">
                                <div class="d-flex justify-content-end">
                                    <button
                                        class="btn btn-sm btn-primary me-2"
                                        type="button"
                                        @click="inputFocusEvent"
                                    >
                                        <span class="tf-icons bx bx-plus"></span
                                        >&nbsp; Tambah Sarana
                                    </button>
                                    <button
                                        ref="updateBtn"
                                        id="showToastPlacement"
                                        class="btn btn-sm btn-warning"
                                        type="button"
                                        @click="getVehicle(halaman)"
                                    >
                                        <span
                                            class="tf-icons bx bx-refresh"
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive text-nowrap">
                <table class="table table-hover">
                    <caption class="ms-4" v-if="vehicles.total > 0">
                        Showing
                        {{
                            vehicles.from
                        }}
                        to
                        {{
                            vehicles.to
                        }}
                        of
                        {{
                            vehicles.total
                        }}
                        Sarana
                    </caption>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th colspan="2">Aksi</th>
                            <th>QrCode</th>
                            <th>Unit Sarana</th>
                            <th>person in charge (PIC)</th>
                            <th>Tanggal Kontrak Berakhir</th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>No</th>
                            <th colspan="2">Aksi</th>
                            <th>QrCode</th>
                            <th>Unit Sarana</th>
                            <th>person in charge (PIC)</th>
                            <th>Tanggal Kontrak Berakhir</th>
                        </tr>
                    </tfoot>
                    <tbody class="table-border-bottom-0">
                        <tr v-for="(a, b) in vehicles.data" :class="a.status? '':'table-danger'" >
                            <td>
                                <strong>{{ vehicles.from + b }}</strong>
                            </td>
                            <td >
                                <div class="dropdown">
                                    <button
                                        type="button"
                                        class="btn  p-0 dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    ><small >Menu</small>
                                    </button>
                                    <div class="dropdown-menu">
                                        <button
                                            class="dropdown-item"
                                            @click="detailSarana(a.idVehicle)"
                                        >
                                            <i class="bx bx-table me-1"></i>
                                            Detail
                                        </button>
                                        <button
                                            class="dropdown-item"
                                            @click="editSarana(a.idVehicle)"
                                        >
                                            <i class="bx bx-edit-alt me-1"></i>
                                            Edit
                                        </button>
                                        <button v-if="a.status ==1"
                                            class="dropdown-item"
                                            @click="disableSarana(a.idVehicle,a.status)"
                                        >
                                            <i class="bx bx-x me-1"></i>
                                            Disable
                                        </button>
                                        <button v-if="a.status ==0"
                                            class="dropdown-item"
                                            @click="disableSarana(a.idVehicle,a.status)"
                                        >
                                            <i class="bx bx-check me-1"></i>
                                            Disable
                                        </button>
                                        <button
                                            class="dropdown-item"
                                            @click="del(a.idVehicle)"
                                        >
                                            <i class="bx bx-trash me-1"></i>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: center">
                                <span
                                    :class="
                                        a.status
                                            ? 'badge me-1 bg-label-success'
                                            : 'badge me-1 bg-label-danger'
                                    "
                                    >{{
                                        a.status == 1 ? "Active" : "Disabled"
                                    }}</span
                                >
                            </td>
                            <td>
                                <qrcode-vue v-if="domainhosts!=null" :value="domainhosts+a.uidVehicle" level="H" :image-settings='imageSettings' render-as="canvas" margin="1" size="50"/>
                                </td>
                            <td>
                                {{ a.noLambung }} ( {{ a.noPol }} )
                                <br> {{ a.merek }} - {{ a.type }}
                            </td>
                            <td>{{ a.pic }}
                            </td>
                            <td><span v-if="isToday(a.kontrak)" class="text-danger">{{ moment(a.kontrak).format("DD MMMM YYYY") }} </span>
                            <span v-else>{{ moment(a.kontrak).format("DD MMMM YYYY") }}</span></td>
                        </tr>
                        <tr v-if="vehicles.total == 0">
                            <td>Tidak Ada Data</td>
                        </tr>
                    </tbody>
                </table>
                <div style="margin-top: 100px;">

                </div>
            </div>
            <div class="card-footer">
                <Bootstrap5Pagination
                    :data="vehicles"
                    @pagination-change-page="getVehicle"
                />
            </div>
        </div>
        <!--/ Hoverable Table rows -->
        <!-- Form Sarana -->
        <form-sarana
            @tabelSaranaEmit="doEmits"
            ref="focusRef"
            :tokens="tokens"
        ></form-sarana>

        <detail-sarana
            ref="focusDetailRef"
        ></detail-sarana>
    </div>
</template>

<script>
import axios from "axios";
import { Bootstrap5Pagination } from "laravel-vue-pagination";
import FormSarana from "./form/lv.vue";
import { ref } from "vue";
import moment from "moment";
import QrcodeVue, { QrcodeCanvas, QrcodeSvg ,ImageSettings} from 'qrcode.vue'

const focusRef = ref(null);

export default {
    components: {
        Bootstrap5Pagination,
        FormSarana,
        QrcodeSvg,
        QrcodeCanvas,
        QrcodeVue,
    },
    mounted() {
        if(this.domainhost!=null) this.domainhosts = this.domainhost+"/landing/main/"
        this.csrfTokens = this.tokens;
        this.getVehicle(this.halaman);
        var thisFocus = this;
        var myOffcanvas = document.getElementById("offcanvasBoth");

        myOffcanvas.addEventListener("shown.bs.offcanvas", () => {
            thisFocus.$refs.focusRef.focusInputs();
        });
        console.log("Host : "+this.domainhosts)
    },
    data() {
        return {
            moment: moment,
            vehicles: {},
            halaman: 1,
            csrfTokens: "",
            domainhosts:null
        };
    },
    props: ["tokens","domainhost"],
    methods: {
        toast() {
            $("#myToast").toast("show");
        },
        getVehicle(page) {
            if (page != undefined) {
                this.halaman = page;
            }
            axios
                .get("/sarana/lv/create?page=" + this.halaman)
                .then((response) => {
                    var vehicle = response.data;
                    if (vehicle != null) {
                        this.vehicles = vehicle;
                    }
                });
        },
        del(idVehicle) {
            axios.delete("/sarana/lv/" + idVehicle).then((response) => {
                if (response != null) {
                    this.vehicles = {};
                    this.getVehicle(this.halaman);
                }
            });
        },
        doEmits() {
            this.getVehicle(this.halaman);
        },
        inputFocusEvent() {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.initDatas();
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

            bsOffcanvas.toggle();
        },
        editSarana(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.getByIds(id);
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        detailSarana(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasDetailBoth");
            thisFocus.$refs.focusDetailRef.getByIds(id);
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        disableSarana(id,status) {
            console.log("ID : "+id+" Status : "+status);
            axios.put("/sarana/lv/enable-" + id, {_token: this.csrfTokens, status: status, }).then((response) => {
                var data = response.data;
                if (data != null) {
                    this.vehicles = {};
                    this.getVehicle(this.halaman);
                }   
            });
        },
         isToday(dateToCheck) {
            const today = new Date();
            const inputDate = new Date(dateToCheck); 
            return (inputDate<=today)?  true : false;
        }
    }   ,
};
</script>
